<template>
  <div class="pb-16 pt-6 lg:py-24" :class="background">
    <div class="mx-auto w-full max-w-screen-xl container">
      <div class="grid grid-cols-1 items-center gap-x-20 gap-y-10 lg:grid-cols-2">
        <div :class="[imagePosition === 'right' ? 'order-2 lg:order-1' : 'order-1 lg:order-2']">
          <VcTypography v-if="title" tag="h2" class="mb-4">
            {{ title }}
          </VcTypography>
          <div class="text-lg" v-html-safe="subtitle"></div>
          <div v-if="buttons && buttons.length" class="mt-6 flex space-x-6 lg:mt-14">
            <template v-for="(item, index) in buttons" :key="index">
              <a
                class="w-1/2 lg:w-auto bg-[color:var(--color-primary-500)] text-white uppercase font-black py-3 px-4 rounded-md text-14"
                :href="item.link"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
        </div>

        <div
          class="aspect-video rounded bg-neutral-200"
          :class="[imagePosition === 'right' ? 'order-1 lg:order-2' : 'order-2 lg:order-1']"
        >
          <VcImage :src="image" :alt="imageDescription" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type ImagePositionType = "left" | "right";
type ButtonType = {
  label: string;
  link: string;
};

interface IProps {
  id: string;
  background?: string;
  title?: string;
  subtitle?: string;
  image?: string;
  imageDescription?: string;
  imagePosition?: ImagePositionType;
  buttons?: Array<ButtonType>;
}

defineProps<IProps>();
</script>

<style lang="scss">
.call-to-action-with-image-block {
  &.bg-neutral-800 {
    color: white;
  }
}
</style>
